import { render, staticRenderFns } from "./CRMActivity.vue?vue&type=template&id=4e648eaf&scoped=true&"
import script from "./CRMActivity.vue?vue&type=script&lang=js&"
export * from "./CRMActivity.vue?vue&type=script&lang=js&"
import style0 from "./CRMActivity.vue?vue&type=style&index=0&id=4e648eaf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e648eaf",
  null
  
)

export default component.exports